import * as React from "react";
import * as ReactDOM from "react-dom";
import { OptionalLink } from "../optionalLink";

interface IProperties
{
    /**
     * Anzeige Text.
     */
    text?: string,

    /**
     * Name des Icons welches angezeigt werden soll.
     */
    icon?: string,

    /**
     * Link (react-router).
     */
    linkTo?: string | {},

    /**
     * Ein Wert der angibt, ob der Indikator für ungelesene Nachrichten angezeigt werden soll.
     */
    notifierCount?: number,

    /**
     * Wird ausgeführt, sobald auf das Item geklickt wird.
     */
    onClick?: (e: MouseEvent) => void
}

export class HeaderItem extends React.Component<IProperties>
{
    /**
     * Führt die "onClick" Eigenschaft aus wenn diese gesetzt wurde.
     * @param e Das auslösende Ereignis.
     */
    private onClick = (e: React.MouseEvent<HTMLElement>) =>
    {
        this.props.onClick && this.props.onClick(e.nativeEvent);
    }

    /**
     * Rendert diese Komponente.
     */
    public render(): JSX.Element
    {
        const { text, icon, linkTo, notifierCount } = this.props;

        var content: JSX.Element = null;
        if (text != null)
        {
            content = <span className="header_item_text">{text}</span>;
        }
        else if (icon != null)
        {
            content = <i className={`header_item_icon mdi mdi-${icon}`}></i>;
        }

        var count: string = null;
        if (notifierCount > 0 && notifierCount > 99)
            count = "99+";
        else if (notifierCount > 0)
            count = notifierCount.toString();

        return (
            <OptionalLink
                className="header_item"
                data-count={count}
                to={this.props.linkTo}
                onClick={this.onClick}>
                {content}
            </OptionalLink>
        );
    }
}